import React from 'react';
import { Checkmark } from '../../../constants/selectFilter.js';
import { MF_BLANK, MF_NOT_BLANK } from '../../../constants/selectFilter.js';

const RMSSelectFilterFooter = ({
  selected,
  toggle,
  getLabel,
  query,
  visible,
  nonSentinelTotal,
  nonSentinelSelected,
  isActive,
  onChange,
}) => {
  return (
    <>
      <div className="multi-filter-sentinel-row">
        {[MF_BLANK, MF_NOT_BLANK].map((s) => {
          const chk = selected.includes(s);
          return (
            <div
              key={s}
              className={['multi-filter-sentinel-item', chk ? 'checked' : ''].join(' ')}
              onMouseDown={(e) => {
                e.preventDefault();
                toggle(s);
              }}>
              <div className={['multi-filter-sentinel-checkbox', chk ? 'checked' : ''].join(' ')}>
                {chk && <Checkmark size={8} />}
              </div>
              {getLabel(s)}
            </div>
          );
        })}
      </div>

      <div className="multi-filter-footer">
        <span className="multi-filter-footer-count">
          {query.trim()
            ? `${visible.length} of ${nonSentinelTotal} shown`
            : `${nonSentinelSelected} of ${nonSentinelTotal} selected`}
        </span>
        {isActive && (
          <button
            className="multi-filter-clear-btn"
            onMouseDown={(e) => {
              e.preventDefault();
              onChange([]);
            }}>
            Clear
          </button>
        )}
      </div>
    </>
  );
};

export default RMSSelectFilterFooter;
